import { Card, CardContent, Grid, Typography, Divider, List, ListItem, ListItemButton } from "@mui/material";
import { useEffect, useState } from "react";

const ForgotPasswordDetailsCard = ({ vendorList, selectedVendor, setSelectedVendor }: any) => {
  // const [selectedVendor, setSelectedVendor] = useState(null);

  const handleSelectVendor = (selectVendor) => {
    const details = [
      { label: "Vendor Code", value: selectVendor?.partner || selectVendor?.lifnr },
      { label: "Name", value: selectVendor?.name },
      { label: "Address", value: selectVendor?.address },
      { label: "Street / House", value: selectVendor?.streetHouse },
      { label: "City", value: selectVendor?.city },
      { label: "Post Code", value: selectVendor?.postCode },
      { label: "District", value: selectVendor?.district },
      { label: "PAN", value: selectVendor?.pan },
      { label: "Bank Account", value: selectVendor?.bankAccount },
      { label: "Tax Number", value: selectVendor?.taxNumber },
      { label: "Contact Number", value: selectVendor?.contactNumber },
      { label: "Email Id", value: selectVendor?.emailId },
      // { label: "Vendor Code", value: selectVendor?.lifnr },
    ];
    setSelectedVendor(details);
  };

  useEffect(() => {
    if (vendorList.length === 1) {
      handleSelectVendor(vendorList[0]);
    }
  }, [vendorList]);

  return (
    <Card sx={{ width: "100%", borderRadius: 2, boxShadow: 2 }}>
      <CardContent>
        {vendorList?.length > 0 && !selectedVendor ? (
          <Card sx={{ p: 2, borderRadius: 2, boxShadow: 3, maxWidth: 400, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
              Select a Vendor to continue:
            </Typography>

            <List>
              {vendorList?.map((item, index) => (
                <div key={index}>
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => handleSelectVendor(item)}
                      sx={{
                        borderRadius: 2,
                        "&:hover": { backgroundColor: "primary.light", color: "white" },
                      }}
                    >
                      <CardContent sx={{ p: 1 }}>
                        <Typography variant="body1" fontWeight="bold">
                          {item?.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Vendor Code: {item?.partner}
                        </Typography>
                      </CardContent>
                    </ListItemButton>
                  </ListItem>
                  {index < vendorList?.length - 1 && <Divider />}
                </div>
              ))}
            </List>
          </Card>
        ) : (
          <Grid container spacing={1} sx={{ display: "flex", flexDirection: "column" }}>
            {Array.isArray(selectedVendor) &&
              selectedVendor?.map(
                (item) =>
                  item.value && (
                    <Typography variant="body2">
                      <b>{item.label}:</b> {item.value}
                    </Typography>
                  )
              )}
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default ForgotPasswordDetailsCard;
